// extracted by mini-css-extract-plugin
module.exports = {"root":"TabbedViewHandle_root","label":"TabbedViewHandle_label","closeBtn":"TabbedViewHandle_closeBtn"};